import { User } from '@domain/user';
import { useGenericQuery } from '@hooks/use-generic-query';
import { GenericQueryOptions } from '@hooks/use-generic-query.type';
import { UseQueryResult } from '@tanstack/react-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants.type';

const getUserByToken = async () => {
  const url = `${import.meta.env.VITE_USERS_HOST}/v1/me`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetUser = (options?: GenericQueryOptions<User, RequestError>): UseQueryResult<User, RequestError> => {
  return useGenericQuery<User, RequestError>(
    [QUERY_KEYS.getUser],
    () => getUserByToken(),
    {
      ...options,
      meta: {
        ...options?.meta,
        hideLoader: true,
      },
    },
    true
  );
};
